/*
String.prototype.replaceAll = function(search, replacement) {
    var target = this;
    if(target != window){
	    return target.replace(new RegExp(search, 'g'), replacement);
    }
};
*/
bamQueue.addToQueue(function(){
	onLoadFunction();
})

function onLoadFunction(){
	if(typeof attachRateEvents != "undefined"){ //compatibilidad proyectos antiguos
		attachRateEvents();
	};
	//Enter KEYPRESS in forms
	//****************************************************************
	$('input[type=text],input[type=password],input[type=search],input[type=email]').keypress(function(e){
		if(e.keyCode==13){
			e.preventDefault();
			$(this).closest('form').submit();
		}
	})
	$(".accordion.core_animated > dd:first-child > div.content, .accordion.core_animated > li:first-child > div.content").slideToggle("normal").addClass("active");
	tab2select();
 	//interceptModals();
	//$(document).off('ajaxComplete');
   	core_library=new core_dropdown();
/*    	bamQueue.waitForExistance("updateTables",function(){
   		updateTables();
   	},500) */
   	$(document).off('click.button-group',".button-group .button").on('click.button-group',".button-group .button",function(){
	   	$(this).closest('.button-group').find('.button').removeClass('is-active');
	   	$(this).addClass('is-active')
   	})

}


//objeto para el nuevo dropdown como el de foundation 5
//************************************************************************************************************************************************************************************************
var core_dropdown = function(options){
	//data-closeOnWindowEvents
	//data-isFixed  Para elementos que se quedan flotantes en pantalla, calculamos las posiciones de forma diferente
	this.caller;
	this.ddpanel;
	this.toggleX;
	this.toggleY;
	this.outerW;
	this.alignment="";
	this.closeOnWindowEvents = true;
	var parentObj=this;

	if(typeof options != "undefined"){
		if(typeof options.closeOnWindowEvents != "undefined"){ //Se cierra dropdown al scrollear o redimensionar la ventana
			this.closeOnWindowEvents = options.closeOnWindowEvents;
		}
	}
	this.reflow();

	$.fn.extend({
		close_dropdown: function(){
			if( typeof $(this).attr('data-coreDropdown')!='undefined'){
				$(this).each(function(){
					$(this).removeClass('is-open');
					$('[data-coreToggle='+$(this).attr('id')+']').removeClass('is-open');
				});
			}else{
				parentObj.closeall();
			}
		}
	})
	$(document).off('click.core_dropdown').on('click.core_dropdown',function(){
		if($('[data-coredropdown]:hover:not([data-coretoggle])').length == 0 && $('[data-coretoggle]:hover').length == 0){
			parentObj.closeall()
		}
	})

}

core_dropdown.prototype.reflow = function (dropdownToggleElem){
	var parentObj=this;
	if( typeof dropdownToggleElem !="undefined"){
		var attachToElem = dropdownToggleElem;
	}else{
		var attachToElem = false;
	}
	$('[data-coreToggle]').off('click.core_dropDown_Space');
	$('[data-coreToggle]').off('mouseenter.core_dropDown_Space');

	$('[data-coreToggle]').on('click.core_dropDown_Space',function(){
		deployDropdown(this,false);
	})

	$('[data-coreToggle]').on('mouseenter.core_dropDown_Space',function(){
		if(typeof $(this).attr('data-hover') !="undefined"){
			deployDropdown(this,true);
		}
	})

	if(attachToElem){
		if(typeof $(this).attr('data-hover') !="undefined"){
			deployDropdown($(attachToElem),true);
		}else{
			deployDropdown($(attachToElem),false);
		}
	}

/*
	$('[data-coreToggle]').on('mouseleave.core_dropDown_Space',function(){
		if(typeof $(this).attr('data-hover') !="undefined"){
			parentObj.closeall();
		}
					console.log(parentObj.caller)

	})
*/


	function deployDropdown(elemThis,isHover){
		var closeme=false;
		var isHover=isHover;
		var alignment="center";
		var persist = false;
		//Cerramos todas menos la actual
// 		$('[data-coreDropdown]:not(#'+$(this).attr('data-coreToggle')+')').close_dropdown();
		if($(elemThis).length == 0){
			return false;
		}
		if($(elemThis).hasClass('is-open') && !isHover){
			closeme=true;
		}

		if(typeof $(parentObj.caller).attr('data-persist') != "undefined" &&  $(parentObj.caller).attr('data-persist') != "false"){
			persist = true;
		}
		if(!persist){
			$('[data-coreDropdown]').close_dropdown();
		}

 		$(elemThis).addClass('is-open');
 		$('[data-coreDropdown]#'+$(elemThis).attr('data-coreToggle')).addClass('is-open')
		parentObj.caller=elemThis;
		parentObj.ddpanel=$('#'+$(elemThis).attr('data-coreToggle')+'[data-coreDropdown]');
		if(typeof $(parentObj.caller).attr('data-alignment') != "undefined"){
			parentObj.alignment=$(parentObj.caller).attr('data-alignment');
		}

		if(typeof $(parentObj.caller).attr('data-moveToBody') != "undefined" && $(parentObj.caller).attr('data-moveToBody').toLowerCase() !== "false"){
			$('body').append(parentObj.ddpanel)
		}

		$(parentObj.ddpanel).css('position','absolute')

		var scrollTop = $(window).scrollTop();
		if(typeof $(parentObj.caller).attr('data-isFixed') != "undefined" && $(parentObj.caller).attr('data-isFixed').toLowerCase() !== "false"){
			parentObj.toggleY=$(elemThis).offset().top-scrollTop
		}else{
			parentObj.toggleY=$(elemThis).offset().top
		}
		//parentObj.toggleY=$(elemThis).offset().top/* -scrollTop */;




		parentObj.outerW=$(elemThis).width();
		parentObj.toggleX=$(elemThis).offset().left+parentObj.outerW;
		// Centrar horizontalmente
		if(parentObj.alignment=="center"){
			var centrarHorizontalmente = $(elemThis).outerWidth()/2;
			parentObj.toggleX = parentObj.toggleX - centrarHorizontalmente;
		}
		if(parentObj.alignment=="left"){
			parentObj.toggleX = $(elemThis).offset().left;
		}
		if(parentObj.alignment=="right"){
			parentObj.toggleX = $(document).width()-$(elemThis).offset().left - $(elemThis).outerWidth();
		}

		// Colocar bajo el objeto
		var colocarBottom =  $(elemThis).outerHeight();
		parentObj.toggleY = parentObj.toggleY + colocarBottom;
		parentObj.reposition();
		if(!closeme){
			$(parentObj.ddpanel).addClass('is-open');
			$(elemThis).addClass('is-open');

		}else{
			$(parentObj.ddpanel).close_dropdown();
		}
		$(parentObj.ddpanel).data('caller',parentObj.caller);
		$(parentObj.caller).trigger('afterShow');

		//Cerrar al pulsar fuera del contenedor

/*
		$(window).click(function() {
			parentObj.closeall();
		});
		$('[data-coreToggle]').click(function(event){
    		event.stopPropagation();
		});
*/

		if(typeof parentObj.ddpanel != "undefined"){
			$(parentObj.ddpanel).off('mouseleave.core_dropDown_Space').on('mouseleave.core_dropDown_Space',function(){
				$(parentObj.ddpanel).addClass('is-hover');
				if(typeof $(parentObj.caller).attr('data-hover') != "undefined"){ //Cerramos al sacar el raton del panel si está establecido el data-hover
					$(parentObj.ddpanel).close_dropdown();
				}else{	//Si no es data-hover, cerramos el dropdown al hacer click fuera del dropdown
				}
				$(parentObj.caller).trigger('onHide')

			})
		}
	}
	if(this.closeOnWindowEvents){
// 		parentObj.closeall();
	}
	var self = this
	$(document).on('scroll resize',function(event){
		if(typeof $(parentObj.caller).attr('data-closeOnWindowEvents') != "undefined" && $(parentObj.caller).attr('data-closeOnWindowEvents').toLowerCase() !== "false"){
			$(parentObj.ddpanel).close_dropdown();
		}
// 		if(typeof $(parentObj.caller).attr('data-continuousPositioning') != "undefined" && $(parentObj.caller).attr('data-continuousPositioning').toLowerCase() !== "false"){
		clearInterval(window.timerForScroll)

		window.timerForScroll = setTimeout(function(){
			self.reposition();
		}, 500)


// 		}
	})
}
core_dropdown.prototype.reposition = function (options){
	var parentObj=this;
	if($(parentObj.ddpanel).length == 0){
		return false;
	}
	var panelWidth=$(parentObj.ddpanel).outerWidth();
// 	console.log("reposition",parentObj.alignment,parentObj.outerW,parentObj.toggleX,$(parentObj.ddpanel).outerWidth())
	var parentAlignment = parentObj.alignment;
	var xProp = "left";

	if(parentAlignment == "left"){
		if((parentObj.toggleX+panelWidth) > $(window).outerWidth() ){
			parentAlignment = "right";
			parentObj.toggleX = $(document).width() - $(parentObj.caller).offset().left - parentObj.outerW
		}
	}

	if(parentAlignment == "right"){
/*
		console.log("value:",$(parentObj.caller).offset().left - ($(parentObj.ddpanel).outerWidth() - parentObj.outerW))
		console.log("value2:",$(parentObj.caller).offset().left,$(parentObj.ddpanel).outerWidth(),parentObj.outerW);
*/

// 		if($(parentObj.caller).offset().left+parentObj.outerW-$(parentObj.ddpanel).outerWidth() < 0){
		if($(parentObj.caller).offset().left - ($(parentObj.ddpanel).outerWidth() - parentObj.outerW) < 0){
			parentAlignment = "left";
			parentObj.toggleX = $(parentObj.caller).offset().left
		}
	}

	if(parentAlignment == "right"){
		$(parentObj.ddpanel).css({
			'top':parentObj.toggleY+"px",
			'left':'auto',
			'right':parentObj.toggleX+"px"
		});
	}else{
		$(parentObj.ddpanel).css({
			'top':parentObj.toggleY+"px",
			'left':parentObj.toggleX+"px",
			'right':'auto'
		})
	}
}
core_dropdown.prototype.open = function (dropdownToggleElem){
	this.reflow($(dropdownToggleElem),false);
}
core_dropdown.prototype.closeall = function (options){
	var parentObj=this;
	$('[data-coreDropdown],[data-coreToggle]').removeClass('is-open');
	$(parentObj.caller).trigger('onHide');
}


//objeto para el nuevo reveal como el de foundation 6
//************************************************************************************************************************************************************************************************
var core_reveal = function(options){
	var self=this;
	this.defaultZIndex=1000;
	this.zIndex=this.defaultZIndex;


	//$('[data-reveal]').wrap('<div class="reveal-overlay"></div>');
	$.fn.extend({
		core_reveal:function(action,options,callback){
			switch (action){
				case "open":
					var opts = {}
					if(typeof options != "undefined" && options != null){
						opts = options;
					}
					self.open($(this),opts);
				break;
				case "close":
					var opts = {}
					var callbackFn = function(){}

					if(typeof options != "undefined" && options != null){
						opts = options;
					}
					if(typeof callback != "undefined"){
						callbackFn = callback;
					}
					self.close($(this),callbackFn,opts);
				break;
				case "reflow":
					self.reflow($(this));
				break;
			}

		}/*
,
		foundation:function(action){
			switch (action){
				case "open":
					self.open($(this));
				break;
				case "close":
					self.close($(this));
				break;
			}
		}
*/
	})
	self.reflow();



}
core_reveal.prototype.set_dataOpen_events = function(elem){
	if(typeof elem !="undefined"){
		var searchElem=$(elem);
	}else{
		var searchElem=$('[data-open]');
	}
	var searchElem=$('[data-open]');

	$(searchElem).each(function(){
		var destino=$(this).attr('data-open');
		destino="#"+destino;

		$(this).off("click.reveal").on("click.reveal",function(){
			if( typeof $(destino).attr('data-reveal') != "undefined" ){
				$(destino).core_reveal('open');
			}
		})
	})
}

core_reveal.prototype.set_dataClose_events = function(elem){
	var self=this;

	if(typeof elem !="undefined"){
		var searchElem=$(elem);
	}else{
		var searchElem=$(this);
	}
	var searchElem=$('[data-core_reveal-close]');

	$(searchElem).each(function(){
		$(this).off("click").on("click",function(){
			var revealElem=$(this).closest("[data-reveal]");
			$(revealElem).core_reveal('close');
		})
	})
}

core_reveal.prototype.open = function(elem,options){
	var self=this;
	var revealParams = {};
	var revealPostParams = {};

	//Wrapper de propiedades del Reveal de Foundation 6
	var multipleOpened=false;
	var closeOnClick=true;
	var dataVOffset=false;

	if(typeof $(elem).attr('data-multiple-opened') != "undefined"){
		var attr=$(elem).attr('data-multiple-opened'); if (attr.toLowerCase()=="true"){ multipleOpened=true }
	}
	if(typeof $(elem).attr('data-close-on-click') != "undefined"){
		var attr=$(elem).attr('data-close-on-click'); if (attr.toLowerCase()=="false"){ closeOnClick=false }
	}
	if(typeof $(elem).attr('data-v-offset') != "undefined"){
		dataVOffset=parseInt($(elem).attr('data-v-offset'));
	}

	if(!multipleOpened){
		$('.reveal-overlay').add('[data-reveal]').removeClass('is-active');
		$(document).ready(function(){
			$(elem).trigger('closeme.zf.reveal');
		})
	}

	if(typeof options != "undefined"){
		if(typeof options.params != "undefined"){
			revealParams = options.params;
			$(elem).attr('data-reveal-params',JSON.stringify(revealParams))
		}
		if(typeof options.postparams != "undefined"){
			revealPostParams = options.postparams;
			$(elem).attr('data-reveal-postparams',JSON.stringify(revealPostParams))
		}
	}

	$(elem).closest('.reveal-overlay').addClass('is-active')
	$(elem).addClass('is-active');

	if(dataVOffset){
		$(elem).css('top',dataVOffset+"px");
	}

	$(this).unbind("close.zf.trigger").bind("close.zf.trigger",function(){
		self.close($(this))
	})
	if(multipleOpened){
		$(this).css('z-index',getHighestIndex()+1)
	}

	$(document).ready(function(){
		$(elem).trigger('open.zf.reveal');
	})


	if(closeOnClick){
		$(elem).closest('.reveal-overlay').off('click').on('click', function(){
// 			if (!$(elem).is(':hover')) {
			if (!$(elem).closest('[data-reveal]').is(':hover')) {
        		$(elem).each(function(){
	        		if(typeof $(this).attr('data-reveal') != "undefined"){
						self.close($(this));
	        		}
        		})
			}
		})
	}

	function getHighestIndex(){
		$('.reveal-overlay').each(function(){
			if($(this).css('z-index') > self.zIndex){
				self.zIndex = $(this).css('z-index');
			}
		})
		return parseInt(self.zIndex);
	}
	$('body').attr('data-showingReveal',"true");
}
core_reveal.prototype.reflow = function(elem){
	//Asignamos eventos a las nuevas ventanas abiertas, buscando nuevos reveal dentro de los reveal abiertos.
	//Si se pasa un elemento, sólo busca dentro de ese reveal para optimizar.
	var self=this;

	//Reasignamos DATA-OPEN encontrados dentro del modal
	if(typeof elem !="undefined"){
		var searchElem=$(elem);
		var dataOpenElem=$(searchElem).find('[data-open]');
		self.set_dataOpen_events($(dataOpenElem));
	}else{
		self.set_dataOpen_events();
	}

	//Reasignamos DATA-CLOSE encontrados dentro del modal
	if(typeof elem !="undefined"){
		var searchElem=$(elem);
		var dataOpenElem=$(searchElem).find('[data-core_reveal-close]');
		self.set_dataClose_events($(dataOpenElem));
	}else{
		self.set_dataClose_events($(this));
	}



	if(typeof elem !="undefined"){
		var searchElem=$(elem).find('[data-reveal]');
	}else{
		var searchElem=$('[data-reveal]');
	}

	if($(searchElem).length > 0){
		$(searchElem).each(function(){
			var currentID = $(this).attr('id');
			if(typeof elem != "undefined" && ( typeof $(this).attr('data-multiple-opened') != "undefined" && $(this).attr('data-multiple-opened').toLowerCase()=="true" ) ){
				//Si esta anidado en otro elemento, y esta puesto como multiple, se le añade el padre
				if($(this).closest('[data-reveal]').length > 0){
					$(this).data("parentModal",$(this).parent().closest('[data-reveal]'))
				}
			}

			if($(this).parent('body').length == 0 && $(this).parent('.reveal-overlay').length == 0 && $('[id="'+currentID+'"]').length <= 1 ){
				$(this).appendTo('body');
			}
			if($(this).parent('.reveal-overlay').length == 0){
				$(this).wrap('<div class="reveal-overlay"></div>');
			}

		})
	}else{
		$(elem).parent('.reveal-overlay').appendTo('body');
	}

}

core_reveal.prototype.close = function(elem,callback,options){
	var self=this;
	var clearParamsOnClose = false;
	if(typeof options != "undefined"){
		if(typeof options.clearParamsOnClose != "undefined"){
			clearParamsOnClose = options.clearParamsOnClose;
		}
	}
	$('[data-reveal]').each(function(){
		//Buscamos si hay otro modal hijo de este, para eliminarlo cuando cerremos el padre y no duplicar eventos
		if( elem[0] != undefined && !elem[0].isSameNode($(this)[0]) ){
			if( typeof $(this).data('parentModal') != "undefined"){
				var parentElem = $(this).data('parentModal')
				if( parentElem[0].isSameNode($(elem)[0]) ){
					$(this).closest('.reveal-overlay').remove();
					$(this).remove();
				}
			}
		}
	})
	if(clearParamsOnClose){
		$(elem).removeAttr('data-reveal-params').removeAttr('data-reveal-postparams')
	}

	$(elem).closest('.reveal-overlay').removeClass('is-active');
	$(elem).removeClass('is-active').css('z-index',self.defaultZIndex);

	$(document).ready(function(){
		$(elem).trigger('closed.zf.reveal');
		if(typeof callback != "undefined" && callback != null){
			callback(elem);
		}
	})
	if($('[data-reveal].is-active').length == 0 || $('[data-reveal].is-active').length == 1){
		$('body').removeAttr('data-showingReveal');
	}
}


//Disabling unavailable tabs
//****************************************************************
	//$('[data-tab] li.disabled').click(function(){return false;})
//****************************************************************


//Accordion Animated
//****************************************************************

 $(".accordion.core_animated > dd.accordion-navigation > a:first-child, .accordion.core_animated > li.accordion-navigation > a:first-child").on("click", function (event)
	{
	  var dd_parent = $(this).closest('.accordion-navigation');

	  if(dd_parent.hasClass('active'))
	    $(".accordion.core_animated > dd > div.content:visible,.accordion.core_animated > li > div.content:visible").slideToggle("normal");
	  else
	  {
	    $(".accordion.core_animated > dd > div.content:visible,.accordion.core_animated > li > div.content:visible").slideToggle("normal");
	    $(this).closest('.accordion-navigation').find(".content:eq(0)").slideToggle("normal");
	  }
	});


//Tabs-to-Select converter
//****************************************************************
//Adquiere la funcionalidad de un control de tabs cuando estas no
//sean viables por su tamaño. Hay que indicar el id del control TABS
//del que obtendrá sus elementos de la forma <SELECT data-tab="myTabs"></SELECT>
//Los eventos clicks los ejecutará en el control nativo de TABS, por lo
//que es necesario que este exista.

function tab2select(){

	$("select[data-tab]").each(function(){

		var tab2convert=$(this).attr('data-tab');
		currentSelect=$(this);
		tabs=new Array();

		if(tab2convert!=""){
			tabsArray=$("#"+tab2convert+" > LI a,#"+tab2convert+" > dd a");
			$(tabsArray).each(function(){
				tabs.push([$(this).text(),$(this).attr('href')]);
			})
		}
		$(tabs).each(function(){
			var optionElem='<option value="'+this[1]+'">'+this[0]+'</option>';
			$(currentSelect).append(optionElem)
		})
		$(currentSelect).find('option').eq($("#"+tab2convert+" > LI.active,#"+tab2convert+" > dd.active").index()).attr('selected','selected');
		$(currentSelect).change(function(){
			$("#"+tab2convert+" >LI a[href='"+$(this).val()+"'],#"+tab2convert+" >dd a[href='"+$(this).val()+"']").click();
		})

	})

}



//función que añade el menú para compartir un artículo en redes sociales
//************************************************************************************************************************************************************************************************

	//Uso: attachShare('article.core_news',"{$DOMAIN}",'{$TWITTER_ACCOUNT}');

	function attachShare(selectorForArticle,domain,twitterAccount,options){
		var fbMethod = "normal";

		if(typeof options != "undefined"){
			if (typeof options.fbUsesIntent != "undefined" && options.fbUsesIntent === true){
				fbMethod = "intent";
			}
		}

		function createSharePanel(){
				$('#shareNews').remove();
				var html='<ul id="shareNews" data-dropdown class="dropdown-pane left" aria-hidden="true">'
						+'<li><a href="javascript:void(null)" data-shareService="tw"><i class="info icon-twitter"></i> Twitter</a></li>'
						+'<li><a href="javascript:void(null)" data-shareService="fb"><i class="info icon-facebook"></i> Facebook</a></li>'
						+'<li><a href="javascript:void(null)" data-shareService="em" disabled="disabled" class="disabled"><i class="info icon-envelope2"></i> Email</a></li>'
						+'</ul>';
				$('body').append(html);
		}


		//Guardamos datos de referencia para generar los enlaces para compartir
		$('[data-share]').click(function(){
				createSharePanel()
				$('[data-toggle="shareNews"]').removeAttr('data-toggle');
				$(this).attr('data-toggle','shareNews');
				var options = {closeOnClick:true}
				var shareNews=new Foundation.Dropdown($('#shareNews'),options);
				$('#shareNews[data-dropdown]').removeAttr('data-newsTitleToShare');
				$('#shareNews[data-dropdown]').removeAttr('data-newsURLToShare');
				$('#shareNews[data-dropdown]').attr('data-newsTitleToShare',$(this).closest(selectorForArticle).find('[data-title]').text());
				$('#shareNews[data-dropdown]').attr('data-newsHeadlineToShare',$(this).closest(selectorForArticle).find('[data-headline]').text());
				$('#shareNews[data-dropdown]').attr('data-newsURLToShare',$(this).closest(selectorForArticle).attr('data-url'));
				$('#shareNews[data-dropdown]').attr('data-newsImgToShare',$(this).closest(selectorForArticle).find('[data-img]').attr("src"));
				attachShareEvents();

		})

		function attachShareEvents(){
			$("#shareNews").on("show.zf.dropdown", function() {
					var title=$('#shareNews[data-dropdown]').attr('data-newsTitleToShare');
					var headline=$('#shareNews[data-dropdown]').attr('data-newsHeadlineToShare');
					var url=$('#shareNews[data-dropdown]').attr('data-newsURLToShare');
					var img=$('#shareNews[data-dropdown]').attr('data-newsImgToShare');
					$('#shareNews [data-shareService="tw"]').off("click").click(function(){
						twShare(url,title,twitterAccount);
					})
					$('#shareNews [data-shareService="fb"]').off("click").click(function(){
						if(fbMethod == "normal"){
							fbShare(url,title,headline,img);
						}else if(fbMethod == "intent"){
							fbShareIntent(url,title);
						}

					})
			});
		}

	}


//función sólo para IOS APP que permite usar el sistema nativo para compartir
//************************************************************************************************************************************************************************************************
	function checkSocialOnIOS(type, url) {
		try {
			switch(type) {
				case 1:
					webkit.messageHandlers.fbonios.postMessage("true");
				break;
				case 2:
					webkit.messageHandlers.fbshareonios.postMessage(url);
				break;
				case 3:
					webkit.messageHandlers.twshareonios.postMessage(url);
				break;
				case 4:
					webkit.messageHandlers.linkDeviceToUserAccount.postMessage(url);
				break;
				case 5:
					webkit.messageHandlers.setUserLoggedStatus.postMessage(url);
				break;
			}
		} catch(err) {
			return false;
		}
	}



//Funciones para enable/disable y mantener en espera un botón
//************************************************************************************************************************************************************************************************

	function disableBt(elem){
	if(!$(elem).length) return false;
	if($._data($(elem)[0],"events")){
		if(typeof $._data($(elem)[0],"events").click != "undefined" && $._data($(elem)[0],"events").click.length>0){
			var eventosClick= $._data($(elem)[0],"events").click[0].handler;
		}else{
			var eventosClick=false;
		}
	}else{
		var eventosClick=false;
	}
	$(elem).data({
		 'caption':$(elem).html(),
		 'event': eventosClick,
		 'onclick':$(elem).attr('onclick')
	})
	$(elem).addClass('disabled');
	if( $(elem).is("button") || $(elem).is("input")){
		$(elem).attr('disabled','disabled')
	}
	$(elem).off('click')
	$(elem).removeAttr('onclick')
	$(elem).find('input,textarea').attr('disabled','disabled');
}
	function enableBt(elem){
	$(elem).removeClass('disabled');
	$(elem).html($(elem).data('caption'));
	if($(elem).data('event')!=false){
		$(elem).click($(elem).data('event'));
	}
	if($(elem).data('onclick')!=""){
		$(elem).attr('onclick',$(elem).data('onclick'))
	}
	$(elem).find('input,textarea').removeAttr('disabled');
	if( $(elem).is("button") || $(elem).is("input")){
		$(elem).removeAttr('disabled')
	}
}
	function holdBt(elem,message,options){
	var showClockIcon='<i class="icon-clock2"></i>';
	if(options){
		if(options.showClockIcon==false){
			showClockIcon="";
		}
	}
	disableBt(elem);
	$(elem).html(showClockIcon+message);
}
	function unholdBt(elem){
	enableBt(elem);
}

//Cookies
//************************************************************************************************************************************************************************************************
	parseInt($(this).find('[data-sharefb-value]').text())+1
	//gestion de cookies
	function getCookie(c_name){
	if (document.cookie.length>0){
		var c_start = document.cookie.indexOf(c_name + "=");
		if (c_start != -1){
			c_start = c_start + c_name.length + 1;
			var c_end = document.cookie.indexOf(";",c_start);
			if(c_end == -1) c_end=document.cookie.length;
			return unescape(document.cookie.substring(c_start,c_end));
		}
	}
	return "";
}
	function setCookie(c_name,value,expiredays,options){
		var exdate = new Date();
		if(options?.expirationAsTimestamp && options.expirationAsTimestamp){
			exdate.setTime(expiredays*1000)	//Por defecto js trabaja con milisecs., usamos un timestamp basado en segs.
		}else{
			exdate.setDate(exdate.getDate()+expiredays);
		}
		var expire = "";
		if(expiredays != null){
			if(expiredays != 0){
				expire=";expires=" + exdate.toUTCString();
			}else{
				expire=";expires=0";
			}
		}
		document.cookie = c_name + "=" + escape(value) + (expire + ";path=/;domain=."+getDomainName(window.location.hostname));
	}
	function eraseCookie(c_name) {
	setCookie(c_name,"",-1);
}
	function getDomainName(hostName) {
    return hostName.substring(hostName.lastIndexOf(".", hostName.lastIndexOf(".") - 1) + 1);
}

// Shares
//************************************************************************************************************************************************************************************************
function fbShare(url,title,description,img,callback){
	if(!url) url = location.href;
	checkSocialOnIOS(2, url);
	if(typeof FB != "undefined"){
  		FB.ui({
  		  method: 'share',
  		  href: url,
  		  description: description,
  		  title: title,
  		  picture: img
  		},
  			// callback
  			function(response) {
  			  if (response && !response.error_message) {
  					if(callback!="undefined"){
  						callback();
  					}
  		  	  } else {
  		  	  	//ERROR
  			  }
  			}
  		);
	}
}
function fbShareIntent(url,title){
	if(!url) url = location.href;
	window.open('http://www.facebook.com/sharer/sharer.php?u='+url+'&title='+title,"Facebook","width=550,height=600,scrollbars=no,resizable=true");
}

function ValidURL(url) {
	return /^(https?|s?ftp):\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i.test(url);
}

function twShare(url,title,twitterAccount){
	if(!url) url = location.href;
	checkSocialOnIOS(3, url);
	window.open('https://twitter.com/intent/tweet?text='+title+'&url='+url+'&via='+twitterAccount+'&original_referer=https://'+window.location.hostname,'',"menubar=no,toolbar=no,resizable=yes,width=500, height=300");
}



// Common actions
// ************************************************************************************************************
	//DEPRECATED!!
/* 	function sendValidateEmail(feedbackElem) {
		var elem=$("#validationbar [data-status-msg]");
		if(typeof feedbackElem != "undefined"){
			elem=$(feedbackElem);
		}
		$(elem).html("<i class='loader'></i> Enviando un email de activación a tu cuenta... Espera por favor");
		$.ajax({
			type: "POST",
			url: "/data/?action=sendValidateEmail",
			dataType: 'json',
			success: function(data)	{
				if(data.status == "ok") {
					$(elem).html('Email enviado, <u>comprueba tu correo</u>');
				}
				else {
					$(elem).html(data.error);
				}
			},
			error: function() {
				$(elem).html('Error desconocido');
			}
		});
	} */

	//Refresh responsive tables to recalculate heights after showing in tabs
	$('.tabs').on('toggled', function (event, tab) {
		var panel=$(tab).find('a').attr('href');
		if($(panel+" .responsive").length>0){
  		  updateTables()
		};
  	});


BROWSERDETECT = {
	init: function () {
		this.browser = this.searchString(this.dataBrowser) || "An unknown browser";
		this.isMobile=(/android|webos|iphone|ipad|ipod|blackberry/i.test(navigator.userAgent.toLowerCase()));

		this.version = this.searchVersion(navigator.userAgent)
			|| this.searchVersion(navigator.appVersion)
			|| "an unknown version";
		this.OS = this.searchString(this.dataOS) || "an unknown OS";
	},
	searchString: function (data) {
		for (var i=0;i<data.length;i++)	{
			var dataString = data[i].string;
			var dataProp = data[i].prop;
			this.versionSearchString = data[i].versionSearch || data[i].identity;
			if (dataString) {
				if (dataString.indexOf(data[i].subString) != -1)
					return data[i].identity;
			}
			else if (dataProp)
				return data[i].identity;
		}
	},
	searchVersion: function (dataString) {
		var index = dataString.indexOf(this.versionSearchString);
		if (index == -1) return;
		return parseFloat(dataString.substring(index+this.versionSearchString.length+1));
	},
	dataBrowser: [
		{
			string: navigator.userAgent,
			subString: "Chrome",
			identity: "Chrome"
		},
		{ 	string: navigator.userAgent,
			subString: "OmniWeb",
			versionSearch: "OmniWeb/",
			identity: "OmniWeb"
		},
		{
			string: navigator.vendor,
			subString: "Apple",
			identity: "Safari",
			versionSearch: "Version"
		},
		{
			prop: window.opera,
			identity: "Opera",
			versionSearch: "Version"
		},
		{
			string: navigator.vendor,
			subString: "iCab",
			identity: "iCab"
		},
		{
			string: navigator.vendor,
			subString: "KDE",
			identity: "Konqueror"
		},
		{
			string: navigator.userAgent,
			subString: "Firefox",
			identity: "Firefox"
		},
		{
			string: navigator.vendor,
			subString: "Camino",
			identity: "Camino"
		},
		{		// for newer Netscapes (6+)
			string: navigator.userAgent,
			subString: "Netscape",
			identity: "Netscape"
		},
		{
			string: navigator.userAgent,
			subString: "MSIE",
			identity: "Explorer",
			versionSearch: "MSIE"
		},
		{
			string: navigator.userAgent,
			subString: "Gecko",
			identity: "Mozilla",
			versionSearch: "rv"
		},
		{ 		// for older Netscapes (4-)
			string: navigator.userAgent,
			subString: "Mozilla",
			identity: "Netscape",
			versionSearch: "Mozilla"
		}
	],
	dataOS : [
		{
			string: navigator.platform,
			subString: "Win",
			identity: "Windows"
		},
		{
			string: navigator.platform,
			subString: "Mac",
			identity: "Mac"
		},
		{
			   string: navigator.userAgent,
			   subString: "iPhone",
			   identity: "iPhone/iPod"
	    },
		{
			string: navigator.platform,
			subString: "Linux",
			identity: "Linux"
		}
	]

};



function interceptModals(options) {
	var holdHTMLmsg = false;
	var myTimeOut = {}
	myTimeOut.time= 8000;
	myTimeOut.warnMsg = "Ha ocurrido un error. Reinténtelo de nuevo.";
	myTimeOut.timeOutCallback = function(){
		alert(myTimeOut.warnMsg);
		$('[data-reveal]').core_reveal("close");
	}
	var URL = "/modal/?option=";

	if(typeof options !="undefined"){
		if(typeof options.holdHTML !="undefined"){ holdHTMLmsg=options.holdHTML }
		if(typeof options.timeOut !="undefined"){
			if(typeof options.timeOut.time != "undefined"){ myTimeOut.time=options.timeOut.time}
			if(typeof options.timeOut.warnMsg != "undefined"){ myTimeOut.warnMsg=options.timeOut.warnMsg}
			if(typeof options.timeOut.timeOutCallback != "undefined"){ myTimeOut.timeOutCallback=options.timeOut.timeOutCallback}
		}else{
			timeOut=false;
		}
		if(typeof options.URL != "undefined"){
			URL = options.URL;
		}
	}

	clearTimeout(window.modalTimeOut)

	//Intercepta modales que tengan data-reveal-source, cargando el template correspondiente
	//**************************************************************************************
	//Para lanzar con click, han de tener DATA-REVEAL-SOURCE apuntando al template
	//Para lanzar programaticamente, el DIV del reveal, tiene que tener DATA-REVEAL-SOURCE
	$(document).off('open.zf.reveal','[data-reveal]');
// 	$("[data-open][data-reveal-source][data-reveal-params]").off('click'); //Quitamos el event por defecto para poder cambiar el orden de lanzamiento
	$(document).off('click',"[data-open][data-reveal-source][data-reveal-params]");
	$(document).off('click.params',"[data-open][data-reveal-source][data-reveal-params]");
	$(document).off('click',"[data-open][data-reveal-source][data-reveal-postparams]");
	$(document).off('click.params',"[data-open][data-reveal-source][data-reveal-postparams]");
	$(document).off('click.params',"[data-open][data-reveal-source][data-reveal-params]").on('click.params',"[data-open][data-reveal-source][data-reveal-params]",function(){
		$('#'+$(this).attr('data-open')).attr("data-reveal-params",$(this).attr('data-reveal-params')).data('paramsFromClick',true);
	})
	$(document).off('click.params',"[data-open][data-reveal-source][data-reveal-postparams]").on('click.params',"[data-open][data-reveal-source][data-reveal-postparams]",function(){
		$('#'+$(this).attr('data-open')).attr("data-reveal-postparams",$(this).attr('data-reveal-postparams')).data('paramsFromClick',true);
	})

/*
	$("[data-open][data-reveal-source][data-reveal-params]").off('click.params').on('click.params',function(){
		$('#'+$(this).attr('data-open')).attr("data-reveal-params",$(this).attr('data-reveal-params')).data('paramsFromClick',true);
	})
*/

/*
	if(typeof core_reveal.set_dataOpen_events != "undefined"){
		core_reveal.set_dataOpen_events(); //Relanzamos los eventos asociados a los data-open
	}
*/

	/** DEPRECATED */
	$("[data-open][data-reveal-source][data-callback]").off('click.callback').on('click.callback',function(){
		$('body').data('setLoginCallback',$(this));
	})



	$(document).on('open.zf.reveal','[data-reveal]',function (el) {
		//Buscamos que este modal desplegado sea de los interceptados y que no vengan de un click interceptado
		if(typeof $(this).attr("data-reveal-source")!='undefined'){
			if(typeof $(this).attr('data-reveal-params')!='undefined' || typeof $(this).attr('data-reveal-postparams')!='undefined'){
				currentScrollFix=$(window).scrollTop();
				var params = false;
				var postparams = false;
				if(typeof $(this).attr('data-reveal-params')!='undefined'){
					params = $(this).attr('data-reveal-params');
				}
				if(typeof $(this).attr('data-reveal-postparams')!='undefined'){
					postparams = $(this).attr('data-reveal-postparams');
				}
				retrieveModalContent($(this),$(this).attr("data-reveal-source"),params,postparams,{holdHTML:holdHTMLmsg,timeOut:myTimeOut,URL:URL});
				if(typeof $(this).data("paramsFromClick")!="undefined" && $(this).data("paramsFromClick")==true){
					$(this).removeAttr('data-reveal-params'); //si los parámetros vienen de un click y no se lanza el modal programáticamente, los borramos para que no se pasen por error si alguien vuelve a invocarlo
					$(this).removeAttr('data-reveal-postparams');
				}
			}else{
				retrieveModalContent($(this),$(this).attr("data-reveal-source"),false,false,{holdHTML:holdHTMLmsg,timeOut:myTimeOut,URL:URL});
				currentScrollFix=$(window).scrollTop();
			}
		}
	});


	$(document).off('closed.zf.reveal','[data-reveal]');
	$(document).on('closed.zf.reveal','[data-reveal]',function(){
		$(window).off('scroll.reveal').on('scroll.reveal',function(e){
			if(typeof currentScrollFix != "undefined"){
				window.scrollTo(0,currentScrollFix)
				$(window).off('scroll.reveal');
			}
		})
	})
/*
	$('[data-reveal]').off('closed.zf.reveal').on('closed.zf.reveal',function(){
		$(window).off('scroll.reveal').on('scroll.reveal',function(e){
			window.scrollTo(0,currentScrollFix)
			$(window).off('scroll.reveal');
		})
	})
*/

}
function retrieveModalContent(modalElem,modalToShow,parameters,postparameters,options){
	var paramString="";
	var postparamString="";

	var callback=false;
	var postcallback=false;
	var callbackInData=false;
	var holdHTMLmsg='<div class="text-center core_spaceT"><div class="core_panel bordered radius core_halfThin core_inlineBlock" style="border-radius:10px"><span class="white core_light"> <img src="//cdn.inicium.com/images/common/loaders/loader1.svg" class="imgSize size20 core_styleMiddle"> <small class="core_styleMiddle core_inlineBlock">CARGANDO...</small></span></div></div>';
	var myTimeOut=false;
	var URL = "/modal/?option=";
	if(typeof $(modalElem).data('callback')!="undefined"){
		callbackInData=$(modalElem).data('callback');
	}
	if(parameters){
		var modalParams=jQuery.parseJSON( parameters )

		for(var i in modalParams){
			if (i!="callback"){
				paramString = paramString+"&"+i+"="+modalParams[i];
			}else{
				callback=modalParams[i];
			}
		}
	}

	if(postparameters){
		var modalParams=jQuery.parseJSON( postparameters )
		postparameters = modalParams;
		for(var i in modalParams){
			if (i=="callback"){
				postcallback=modalParams[i];
			}
		}
	}

	if(typeof options !="undefined"){
		if(typeof options.holdHTML !="undefined"){
			if(options.holdHTML){ holdHTMLmsg=options.holdHTML }
		}
		if(typeof options.timeOut !="undefined"){
			if(options.timeOut){
				myTimeOut=options.timeOut;
			}else{
				myTimeOut=false;
			}
		}
		if(typeof options.URL != "undefined"){
			URL = options.URL;
		}
	}
	if(typeof window["modalTimeOut"] != "undefined"){
		clearTimeout(window.modalTimeOut)
		delete window["modalTimeOut"];
	}
	retrieveModalContentOptions=options;
	$(modalElem).html(holdHTMLmsg);

// 	if(typeof bam_mainurl == "undefined") { bam_mainurl = "/"; }

	if(myTimeOut){
		window.modalTimeOut=setTimeout(function(){myTimeOut.timeOutCallback();clearTimeout(window.modalTimeOut)}, myTimeOut.time)
//  			console.log("estableshing timeout",window.modalTimeOut)
	}

	$.post( /*bam_mainurl+*/URL+modalToShow+paramString,postparameters,
	function( data ) {
		clearTimeout(window.modalTimeOut)
		delete window["modalTimeOut"];
// 		console.log("cleared Timeout", window.modalTimeOut, window["modalTimeOut"])

		$(modalElem).html(data);
		if(callback || postcallback || callbackInData){
			$(document).on('ajaxComplete.modalsCallback',function(event, xhr, settings){

				if(settings.url==/*bam_mainurl+*/URL+modalToShow+paramString){
					if(callback){
						var callbackFn=eval('('+callback+')');
						if(typeof callbackFn=="undefined"){
							eval(callback);

						}else{
							callbackFn();
						}
					}
					if(postcallback){
						var postcallbackFn=eval('('+postcallback+')');
						if(typeof postcallbackFn=="undefined"){
							eval(postcallback);

						}else{
							postcallbackFn();
						}
					}
					if(callbackInData!=false){
						callbackInData();
					}
				}
				$(document).off('ajaxComplete.modalsCallback');

			})
		}
		$(modalElem).off('closed.zf.reveal').on('closed.zf.reveal',function () {
			$(modalElem).empty();
		})
		$(modalElem).core_reveal("reflow");
		reflowModals(options);
		if (typeof launchEventListeners === "function"){
			launchEventListeners();
		}
		$(modalElem).foundation()
		$(modalElem).find('form[data-abide]').off('submit.bam').on('submit.bam', function(ev,frm) {
			ev.preventDefault();
		})

		interceptModals(retrieveModalContentOptions);
		$(window).trigger('resize');
	});
}

/*
 * JSONfn v1.1.0
 * (c) 2013 - 2016 Vadim Kiryukhin; vkiryukhin @ gmail.com; http://www.eslinstructor.net/jsonfn/
 * License: MIT
 */
(function(a){a.stringify=function(a){return JSON.stringify(a,function(a,b){var d;return b instanceof Function||"function"==typeof b?(d=b.toString(),8>d.length||"function"!==d.substring(0,8)?"_NuFrRa_"+d:d):b instanceof RegExp?"_PxEgEr_"+b:b})};a.parse=function(a,f){var b=f?/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2}(?:\.\d*)?)Z$/:!1;return JSON.parse(a,function(a,c){var e;if("string"!=typeof c||8>c.length)return c;e=c.substring(0,8);return b&&c.match(b)?new Date(c):"function"===e?eval("("+c+
")"):"_PxEgEr_"===e||"_NuFrRa_"===e?eval(c.slice(8)):c})};a.clone=function(g,f){return a.parse(a.stringify(g),f)}})("undefined"===typeof exports?window.JSONfn={}:exports);




function reflowModals(options){

	//Enter KEYPRESS in forms
	//****************************************************************

	$('input[type="text"],input[type="password"],input[type="search"],input[type="email"]').keypress(function(e){
		if(e.keyCode==13){
			e.preventDefault();
			$(this).closest('form').submit();
		}
	})
	if(typeof options !="undefined"){
		interceptModals(options);
	}else{
		interceptModals()
	}
}






/*


	myForm = new formeSubmit(
	$(formElem),							//Si false, no hay FORM, sólo una petición AJAX. (Sólo se activan submitBT y statusMsg, si se establece los "elem" explícitamente
	"dataURL",
	{

		submitBt: {
			elem : $("[data-submit]"),		//default: [data-submit]
			submitMsg:  "enviar",			//default: "Enviar"
			holdMsg: "...espere",			//default: "...espere"
			showClockIcon: true				//default: true,
			enableOnSuccess: false			//default: false //Si se establece TRUE reactiva el botón al success.
		},
		statusMsg: {
			elem: $("[data-status-msg]"),	//default: [data-status-msg]
			ok: "Listo!",					//default: ""
			ko: "Error",					//default: ""
			hold: "Enviando",				//default: ""
			error: "No se ha podido hacer la llamada AJAX" //default: ""
			okClasses: "bg_mint",			//default: "success"
			koClasses: "alert"				//default: "alert",
			countDownBeforeCallback: {		//default: false,
				seconds: 4,
				callback: function(){}
			}								//Recibe un objeto cono parámetros seconds: segundos, y callback. Si se activa, se muestra un contador antes de ejecutar el callback
											//Acto seguido, lanza el callback
		},
		redirectURL: "www.w3c.com",			//default: false
		clearOnSubmit: false				//default: false
		extraFields: { "elem": value, "elem2": value...},	//default: false
		extraFieldsAsPost: { "elem" : value, "elem2" : value...} //default: false, se enviarán como POST
		sendDataAsJSON: 					//Envía los datos como JSON en lugar de form,
		ignoreFormFields:					//Ignora los campos del formulario. Sirve para procesar sólo extraFields.
		ignoreOKDefaultActions: false,						//default: false
		ignoreKODefaultActions: false,						//default: false
		callbackOnSuccess: function(e,j) { myFunc1(e) }		//default: function(){} //Si se establece 'e', esté valdrá el 'data' que se reciba de la llamada AJAX. J alberga el valor del objeto forme
		callbackOnFail: function(e) { myFunc2(e) }			//default: function(){}	//Si se establece 'e', esté valdrá el 'data' que se reciba de la llamada AJAX
		callbackOnError: function(e,j) { myFunc3() }		//default: function(){} //llamada cuando existe un error ejecutar lanzar la llamada AJAX,
		sendAsFile: false									//default: false, establece un método de envío alternativo para remitir ficheros.,
		crossDomain:false
	} );

*/

var formeSubmit = function(formElem,dataURL,options){

	this.formElem = formElem;
	this.dataURL = dataURL;


	this.submitBt = {};
	if( this.formElem && $(this.formElem).find("[data-submit]").length > 0){
		this.submitBt.elem=$(this.formElem).find("[data-submit]");
		this.defaultSubmitCaption = $(this.submitBt.elem).html();
	}else{
		this.submitBt.elem=false;
		this.defaultSubmitCaption=false;
	}
	this.submitBt.holdMsg="";
	this.submitBt.showClockIcon=true;
	this.submitBt.enableOnSuccess=false;

	this.statusMsg = {};
	if( this.formElem && $(this.formElem).find("[data-status-msg]").length > 0){
		this.statusMsg.elem=$(this.formElem).find("[data-status-msg]");
	}else{
		this.statusMsg.elem=false;
	}
	this.statusMsg.ok="";
	this.statusMsg.ko="";
	this.statusMsg.hold="";
	this.statusMsg.error="";
	this.statusMsg.okClasses="success";
	this.statusMsg.koClasses="alert";
	this.statusMsg.countDownBeforeCallback = false; //Recibe como parámetros segundos o false. Si se activa, se muestra un contador antes de ejecutar el callback

	this.redirectURL=false;
	this.clearOnSubmit=false;
	this.extraFields=false;
	this.ignoreOKDefaultActions=false;
	this.ignoreKODefaultActions=false;
	this.callbackOnSuccess=function(){};
	this.callbackOnFail=function(){};
	this.callbackOnError=function(){};
	this.serializedData = "";
	this.postData = {};
	this.sendDataAsJSON = false;
	this.ignoreFormFields = false;
	var self = this;

	var parentObj = this;
	this.data=false;
	this.sendAsFile=false;
	this.crossDomain = false;

	if (typeof options != "undefined"){
		if( typeof options.redirectURL 				!= "undefined"){ this.redirectURL = options.redirectURL }
		if( typeof options.clearOnSubmit 			!= "undefined"){ this.clearOnSubmit = options.clearOnSubmit }
		if( typeof options.callbackOnSuccess 		!= "undefined"){ this.callbackOnSuccess = options.callbackOnSuccess }
		if( typeof options.callbackOnFail			!= "undefined"){ this.callbackOnFail = options.callbackOnFail }
		if( typeof options.callbackOnError			!= "undefined"){ this.callbackOnError = options.callbackOnError }
		if( typeof options.countDownCallbackOnSuccess	!= "undefined"){
			if(typeof options.countDownCallbackOnSuccess.seconds != "undefined" && typeof options.countDownCallbackOnSuccess.callback != "undefined"){
				this.countDownCallbackOnSuccess = options.countDownCallbackOnSuccess
			}
		}
		if( typeof options.sendDataAsJSON != "undefined" && options.sendDataAsJSON){ this.sendDataAsJSON = true;this.serializedData = {}	}
		if( typeof options.ignoreFormFields != "undefined" && options.ignoreFormFields){ this.ignoreFormFields = true; }

		if( typeof options.ignoreOKDefaultActions 	!= "undefined" || options.ignoreOKDefaultActions != false){ this.ignoreOKDefaultActions ==  true }
		if( typeof options.ignoreKODefaultActions 	!= "undefined" || options.ignoreKODefaultActions != false){ this.ignoreKODefaultActions ==  true }

		if( typeof options.submitBt != "undefined") {
			if( typeof options.submitBt.elem 			!= "undefined" && ($(options.submitBt.elem).length > 0 || options.submitBt.elem===false)) { this.submitBt.elem = options.submitBt.elem }
			if( typeof options.submitBt.holdMsg 		!= "undefined"){ this.submitBt.holdMsg = options.submitBt.holdMsg }
			if( typeof options.submitBt.showClockIcon 	!= "undefined"){ this.submitBt.showClockIcon = options.submitBt.showClockIcon }
			if( typeof options.submitBt.enableOnSuccess	!= "undefined"){ this.submitBt.enableOnSuccess = options.submitBt.enableOnSuccess }
		}
		if( typeof options.statusMsg != "undefined") {
			if( typeof options.statusMsg.elem 		!= "undefined" && $(options.statusMsg.elem).length > 0){ this.statusMsg.elem = options.statusMsg.elem }
			if( typeof options.statusMsg.ok 		!= "undefined"){
				this.statusMsg.ok = options.statusMsg.ok;
				$(options.statusMsg.elem).removeClass(this.statusMsg.koClasses);
				$(options.statusMsg.elem).addClass(this.statusMsg.okClasses);
			}
			if( typeof options.statusMsg.ko 		!= "undefined"){
				this.statusMsg.ko = options.statusMsg.ko;
				$(options.statusMsg.elem).addClass(this.statusMsg.koClasses);
				$(options.statusMsg.elem).removeClass(this.statusMsg.okClasses);
			}
			if( typeof options.statusMsg.hold 		!= "undefined"){ this.statusMsg.hold = options.statusMsg.hold }
			if( typeof options.statusMsg.error 		!= "undefined"){ this.statusMsg.error = options.statusMsg.error }

			if( typeof options.statusMsg.okClasses	!= "undefined"){ this.statusMsg.okClasses = options.statusMsg.okClasses }
			if( typeof options.statusMsg.koClasses	!= "undefined"){ this.statusMsg.koClasses = options.statusMsg.koClasses }
			if( typeof options.statusMsg.countDownBeforeCallback	!= "undefined"){
				if(typeof options.statusMsg.countDownBeforeCallback.seconds != "undefined" && typeof options.statusMsg.countDownBeforeCallback.callback != "undefined"){
					this.statusMsg.countDownBeforeCallback = options.statusMsg.countDownBeforeCallback;
				}
			}

		}

		if (this.formElem && !this.ignoreFormFields){
			if(!this.sendDataAsJSON){
				this.serializedData = $(this.formElem).serialize()+"&";
			}else{
				var serializedArr = $(this.formElem).serializeArray();
				$(serializedArr).each(function(k,v){
					self.serializedData[v.name] = v.value;
				})
			}
		}

		if( typeof options.sendAsFile != "undefined" )	{
			if(options.sendAsFile==true){
				this.sendAsFile=true;
			}
		}
		if( typeof options.extraFields != "undefined" )	{
			if(!this.sendDataAsJSON){
				this.serializedData = this.serializedData + $.param(options.extraFields);
			}else{
				for (var attrname in options.extraFields) { this.serializedData[attrname] = options.extraFields[attrname]; }
			}
		}
		if( typeof options.extraFieldsAsPost != "undefined" )	{
			$.each(options.extraFieldsAsPost,function(k,v){
				self.postData[k] = v
			})
			if(!this.sendDataAsJSON){
				parentObj.serializedData = parentObj.serializedData + "&" + $.param(self.postData);
			}else{
				for (var attrname in options.extraFieldsAsPost) { this.serializedData[attrname] = options.extraFieldsAsPost[attrname]; }
			}
		}
		if( typeof options.crossDomain != "undefined" )	{
			if( options.crossDomain === true){
				this.crossDomain = true;
			}
		}


	}



	this.xhrObj = null;

	this.xhrObj = submitElement();

	function submitElement() {

		if(parentObj.submitBt.elem){
			if(parentObj.submitBt.holdMsg.length > 0){
				var holdMsg = parentObj.submitBt.holdMsg;
			}else{
				var holdMsg = $(parentObj.submitBt.elem).html();
			}
			holdBt($(parentObj.submitBt.elem),holdMsg,{ "showClockIcon":parentObj.submitBt.showClockIcon});
		}

		if(parentObj.statusMsg.elem) { $(parentObj.statusMsg.elem).hide().html(''); }
		if(parentObj.statusMsg.elem && parentObj.statusMsg.hold.length > 0){
			$(parentObj.statusMsg.elem).html(parentObj.statusMsg.hold).removeClass(parentObj.statusMsg.koClasses).removeClass(parentObj.statusMsg.okClasses).show();
		}


		if(!parentObj.sendAsFile){
			if(!parentObj.sendDataAsJSON){
				var f_data=parentObj.serializedData;
				var f_contentType='application/x-www-form-urlencoded; charset=UTF-8';
			}else{
				var f_data=JSON.stringify(parentObj.serializedData);
				var f_contentType='application/json';
			}
			var f_processData=true;
		}else{
			var f_data = new FormData($(parentObj.formElem)[0]);
			var f_contentType=false
			var f_processData=false;
		}
		if(!parentObj.crossDomain){
			var dataType = "json";
		}else{
			var dataType = "jsonp";
		}
		var xhrObj = $.ajax({
			url: parentObj.dataURL,
			type: 'POST',
			data: f_data,
			cache: false,
			contentType: f_contentType,
			processData: f_processData,
			crossDomain: parentObj.crossDomain,
			dataType: dataType,
			success: function(data)	{
				parentObj.data=data;
				// OK
				if(data.status == "ok") {
					if(!parentObj.ignoreOKDefaultActions){
						if(parentObj.clearOnSubmit) { $(parentObj.formElem).trigger("reset"); }
						if(parentObj.statusMsg.elem){
							if(parentObj.statusMsg.ok.length>0){ //Establecido manualmente un valor de mensaje de ok. Lo usamos
								$(parentObj.statusMsg.elem).html(parentObj.statusMsg.ok).removeClass(parentObj.statusMsg.koClasses).addClass(parentObj.statusMsg.okClasses);
								$(parentObj.statusMsg.elem).fadeOut(function(){ $(this).fadeIn()});
							}else{
								if(typeof data.success != "undefined" && data.success.length>0){ //Si no se establece manualmente, y viene el mensaje en el resultado de la petición, lo usamos
									$(parentObj.statusMsg.elem).html(data.success).removeClass(parentObj.statusMsg.koClasses).addClass(parentObj.statusMsg.okClasses);
									$(parentObj.statusMsg.elem).fadeOut(function(){ $(this).fadeIn()});
								}
							}
						}

					}
					if(parentObj.submitBt.enableOnSuccess){
						unholdBt($(parentObj.submitBt.elem));
						if(parentObj.defaultSubmitCaption){
							$(parentObj.submitBt.elem).html(parentObj.defaultSubmitCaption)
						}
					}
					parentObj.callbackOnSuccess(data,self);

					if(!parentObj.ignoreOKDefaultActions && parentObj.statusMsg.elem && parentObj.statusMsg.countDownBeforeCallback !== false){
						var text = $(parentObj.statusMsg.elem).html();
						let intervalo = parseInt(parentObj.statusMsg.countDownBeforeCallback.seconds);
						$(parentObj.statusMsg.elem).html(text +" (" + intervalo + ")");
						let closeInterval = setInterval(function(){
							intervalo--;
							if(intervalo == 0){
								parentObj.statusMsg.countDownBeforeCallback.callback(data,self);
								clearInterval(closeInterval);
							}else{
								$(parentObj.statusMsg.elem).text(text +" (" + parseInt(intervalo) + ")");
							}
						}, 1000);
					}

					if(parentObj.redirectURL) { window.location.href = parentObj.redirectURL; }
				}
				// KO
				else {
					if(!parentObj.ignoreKODefaultActions){
						if(parentObj.statusMsg.elem){
							if(parentObj.statusMsg.ko.length>0){ //Establecido manualmente un valor de mensaje de ko. Lo usamos
								$(parentObj.statusMsg.elem).html(parentObj.statusMsg.ko).removeClass(parentObj.statusMsg.okClasses).addClass(parentObj.statusMsg.koClasses);;
								$(parentObj.statusMsg.elem).fadeOut(function(){ $(this).fadeIn()});
							}else{
								if( typeof data.error != "undefined" && (data.error).toString().length > 0){
									$(parentObj.statusMsg.elem).html(data.error).removeClass(parentObj.statusMsg.okClasses).addClass(parentObj.statusMsg.koClasses);
									$(parentObj.statusMsg.elem).fadeOut(function(){ $(this).fadeIn()});
								}
							}
						}
					}
					parentObj.callbackOnFail(data,self);
					if(parentObj.submitBt.elem){
						unholdBt($(parentObj.submitBt.elem));
					}
				}

			},
			error: function(xhr, textStatus, errorThrown) {
				// Código común
				if(parentObj.statusMsg.elem){
					if(parentObj.statusMsg.error.length>0){
						$(parentObj.statusMsg.elem).html(parentObj.statusMsg.error).removeClass(parentObj.statusMsg.okClasses).addClass(parentObj.statusMsg.koClasses);;
						$(parentObj.statusMsg.elem).fadeOut(function(){ $(this).fadeIn()});
					}else{
						$(parentObj.statusMsg.elem).html("Error ☠️ ",xhr.responseText).removeClass(parentObj.statusMsg.okClasses).addClass(parentObj.statusMsg.koClasses);
						$(parentObj.statusMsg.elem).fadeOut(function(){ $(this).fadeIn()});
					}
				}
				parentObj.callbackOnError(xhr, textStatus, errorThrown);
				if(parentObj.submitBt.elem){
					unholdBt(parentObj.submitBt.elem);
				}
			}
		});

		return xhrObj;
	}
}

formeSubmit.prototype.getStatusMsgElem = function(){
	var self = this;
	if(typeof self.statusMsg != "undefined" && typeof self.statusMsg.elem != "undefined"){
		return self.statusMsg.elem;
	}
	return false;
}

formeSubmit.prototype.getXHR = function(){
	return this.xhrObj;
}


function objectifyForm(formArray) {//serialize data function

  var returnArray = {};
  for (var i = 0; i < formArray.length; i++){
    returnArray[formArray[i]['name']] = formArray[i]['value'];
  }
  return returnArray;
}
function parseTimezone(tz){
	$("time[data-style]").each(function(item){
		var date = new Date($(this).attr("datetime"));
		if($(this).data("style") == "style1"){
			$(this).html(date.getDate()+" / "+pad(date.getMonth()+1,2)+" ("+date.getHours()+":"+pad(date.getMinutes(),2)+")");
		} else if($(this).data("style") == "style2"){
			$(this).html(date.getDate()+" / "+pad(date.getMonth()+1,2)+"<br>"+date.getHours()+":"+pad(date.getMinutes(),2));
		} else if($(this).data("style") == "style3"){
			$(this).html(date.getHours()+":"+pad(date.getMinutes(),2));
		}
		if(date.getTimezoneOffset() < 0){
			$("[data-timezone]").text("UTC+"+(-date.getTimezoneOffset()/60));
		} else {
			$("[data-timezone]").text("UTC"+(-date.getTimezoneOffset()/60));
		}
	});
}

function getParameterByName(name, urlvalue) {
	var url = window.location.href;
	if(typeof urlvalue != "undefined"){
		url = urlvalue;
	}
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}